import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBorders = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.25 19.25h-8.5m11.5-11.5v8.5m-14.5-8.5v8.5m11.5-11.5h-8.5"
    />
  </svg>
);
export default SvgBorders;
